import type { ApiError } from "@entrilia/shared/api/types";
import type { InvestorPortalFeature } from "../../../../api/types/investorPortalTypes";
import type {
  ApprovalConfigurationVersion,
  CurrentWorkflowApprovalConfigurationResponse,
} from "../../../../api/types/workflowTypes";

interface PortalFeatures {
  liveFeatures: InvestorPortalFeature[];
  previewFeatures: InvestorPortalFeature[];
}

export type ContactsApproval =
  | { status: "NoAccess" }
  | { status: "Loading" }
  | { status: "Failed" }
  | { status: "WorkflowNotActive" }
  | { status: "Loaded"; configuration: ApprovalConfigurationVersion };

export const getContactsApproval = (
  canViewApproval: boolean,
  response: CurrentWorkflowApprovalConfigurationResponse | undefined,
  error: ApiError | undefined
): ContactsApproval => {
  if (!canViewApproval) {
    return { status: "NoAccess" };
  }
  if (error) {
    return { status: "Failed" };
  }
  if (response === undefined) {
    return { status: "Loading" };
  }
  return response.approvalConfiguration
    ? { status: "Loaded", configuration: response.approvalConfiguration }
    : { status: "WorkflowNotActive" };
};

const isContactsApprovalNotConfigured = (contactsApproval: ContactsApproval): boolean =>
  contactsApproval.status === "WorkflowNotActive" ||
  (contactsApproval.status === "Loaded" && contactsApproval.configuration.steps.length === 0);

export const includesContactsSelfService = ({ liveFeatures, previewFeatures }: PortalFeatures): boolean =>
  liveFeatures.includes("All") ||
  liveFeatures.includes("MembershipEditor") ||
  previewFeatures.includes("MembershipEditor");

export const shouldLockContactsEdit = (
  contactsApproval: ContactsApproval,
  isContactsSelfServiceSaved: boolean,
  membershipEdit: boolean
): boolean => isContactsApprovalNotConfigured(contactsApproval) && !isContactsSelfServiceSaved && !membershipEdit;
